import AccessTimeIcon from '@mui/icons-material/AccessTime';
import {
    Box,
    Card,
    CardContent,
    Container,
    Grid,
    Typography,
    useTheme,
} from '@mui/material';
import { useCountdown } from 'hooks/useCountdown';

const Application = () => {
    const theme = useTheme();
    const targetDate = '2026-04-08T17:00:00.000Z';
    const [days, hours, minutes, seconds] = useCountdown(targetDate);

    const countdownItems = [
        { label: 'Days', value: days, color: theme.palette.primary.main },
        { label: 'Hours', value: hours, color: theme.palette.secondary.main },
        { label: 'Minutes', value: minutes, color: theme.palette.success.main },
        { label: 'Seconds', value: seconds, color: theme.palette.warning.main },
    ];

    return (
        <Box bgcolor={theme.palette.alternate.main} py={4}>
            <Container>
                <Box>
                    <Card
                        sx={{
                            mb: 6,
                            background: `linear-gradient(135deg, ${theme.palette.primary.main}15, ${theme.palette.secondary.main}10)`,
                            border: `2px solid ${theme.palette.primary.main}20`,
                            borderRadius: 4,
                            overflow: 'hidden',
                            position: 'relative',
                            '&::before': {
                                content: '""',
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                right: 0,
                                height: 4,
                                background: `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main}, ${theme.palette.success.main}, ${theme.palette.warning.main})`,
                            },
                        }}
                    >
                        <CardContent sx={{ p: { xs: 3, md: 5 } }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    mb: 4,
                                }}
                            >
                                <AccessTimeIcon
                                    sx={{
                                        fontSize: 32,
                                        color: theme.palette.primary.main,
                                        mr: 2,
                                    }}
                                />
                                <Typography
                                    variant="h4"
                                    sx={{
                                        fontWeight: 700,
                                        color: theme.palette.primary.main,
                                        fontSize: { xs: '1.5rem', md: '2rem' },
                                    }}
                                >
                                    Event Starts In Today
                                </Typography>
                            </Box>

                            {/* <Grid container spacing={2} justifyContent="center">
                                {countdownItems.map((item, index) => (
                                    <Grid item xs={6} sm={3} key={index}>
                                        <Box
                                            sx={{
                                                textAlign: 'center',
                                                p: { xs: 2, md: 3 },
                                                borderRadius: 3,
                                                background: 'white',
                                                boxShadow:
                                                    '0 8px 30px rgba(0,0,0,0.1)',
                                                border: `2px solid ${item.color}20`,
                                                transition:
                                                    'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                                '&:hover': {
                                                    transform:
                                                        'translateY(-5px)',
                                                    boxShadow:
                                                        '0 15px 40px rgba(0,0,0,0.15)',
                                                    borderColor: `${item.color}40`,
                                                },
                                            }}
                                        >
                                            <Typography
                                                variant="h2"
                                                sx={{
                                                    fontWeight: 800,
                                                    color: item.color,
                                                    fontSize: {
                                                        xs: '2rem',
                                                        md: '3rem',
                                                    },
                                                    lineHeight: 1,
                                                    mb: 1,
                                                }}
                                            >
                                                {item.value}
                                            </Typography>
                                            <Typography
                                                variant="body1"
                                                sx={{
                                                    color: theme.palette.text
                                                        .secondary,
                                                    fontWeight: 600,
                                                    fontSize: {
                                                        xs: '0.9rem',
                                                        md: '1rem',
                                                    },
                                                    textTransform: 'uppercase',
                                                    letterSpacing: 1,
                                                }}
                                            >
                                                {item.label}
                                            </Typography>
                                        </Box>
                                    </Grid>
                                ))}
                            </Grid> */}
                        </CardContent>
                    </Card>
                </Box>
            </Container>
        </Box>
    );
};

export default Application;
